import { createContext, useContext } from 'react';

export interface DatePickerI18n {
  months?: string[];
  weekDays?: string[];
  format?: (date: Date, format: string) => string;
  parse?: (date: string, format?: string) => Date;
}

const defaultValue: DatePickerI18n = {};

export const DatePickerI18nContext = createContext(defaultValue);

export const useDatePickerI18n = () => useContext(DatePickerI18nContext);
